import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import deviceInfo from "slotworks/utils/device-info";

export default class BetBarResizer {
    public static MOBILE_TEXTS_SCALE = false;

    private defaultPortraitBalanceFontSize: number;
    private defaultLandscapeBalanceFontSize: number;

    // on error to stop trying to scale
    private disabled: boolean = false;

    constructor() {
        this.disabled = false;
    }

    public setListeners() {
        if (!deviceInfo.isDesktop && !deviceInfo.widePortrait && BetBarResizer.MOBILE_TEXTS_SCALE) {
            deviceInfo.onLayoutChange.add(this.onLayoutChange);
        }
    }

    public scaleToFitBalanceOnMobile() {
        if (!deviceInfo.isDesktop && !deviceInfo.widePortrait && BetBarResizer.MOBILE_TEXTS_SCALE) {
            
            if(this.disabled) {
                return;
            }

            if (canvasManager.orientation === Orientation.PORTRAIT) {                 
                try {
                    const betbarBalance = document.querySelector('#portrait #BetBar #default #balance_value') as HTMLElement;
                    if (!betbarBalance) return;
                    const betMenuBalance = document.querySelector('#Menus #betmenu #footer #balance_value') as HTMLElement;
                    const betValue = document.querySelector('#portrait #BetBar #default #total_stake_value') as HTMLElement;
                    const betMenuBetValue = document.querySelector('#Menus #betmenu #footer #total_stake_value') as HTMLElement;
                    const freespinsBalance = document.querySelector('#portrait #BetBar #freespins #balanceContainer #balance_value') as HTMLElement;
                    const freespinsBetValue = document.querySelector('#portrait #BetBar #freespins #total_stake_value') as HTMLElement;
                    
                    if (this.defaultPortraitBalanceFontSize === undefined) {
                        this.defaultPortraitBalanceFontSize = parseInt(window.getComputedStyle(betbarBalance).fontSize);                        
                    }
                    
                    const currentFontSize = this.defaultPortraitBalanceFontSize;
                    const expectedMaxLength = 10;
                    const defaultLength = betbarBalance.textContent?.length || 0;
                    const freespinsLength = freespinsBalance.textContent?.length || 0;
                    const length = defaultLength > freespinsLength ? defaultLength : freespinsLength;
                    if(length <= 12) return;

                    const resizedFontSize = this.downscale(
                        length,
                        expectedMaxLength,
                        currentFontSize,
                        currentFontSize - 6
                    );
                    betbarBalance.style.fontSize = `${resizedFontSize}px`;
                    betMenuBalance.style.fontSize = `${resizedFontSize}px`;
                    betValue.style.fontSize = `${resizedFontSize}px`;
                    betMenuBetValue.style.fontSize = `${resizedFontSize}px`;                    
                    freespinsBalance.style.fontSize = `${resizedFontSize}px`;
                    freespinsBetValue.style.fontSize = `${resizedFontSize}px`;                    
                } catch (e) {
                    this.disabled = true;
                }
            } else {
                try {
                    const betbarBalance = document.querySelector('#landscape #BetBar #default #balance_value') as HTMLElement;
                    if (!betbarBalance) return;
                    const betValue = document.querySelector('#landscape #BetBar #default #total_stake_value') as HTMLElement;
                    const betMenuBalance = document.querySelector('#Menus #betmenu #footer #balance_value') as HTMLElement;
                    const betMenuBetValue = document.querySelector('#Menus #betmenu #footer #total_stake_value') as HTMLElement;
                    const freespinsBalance = document.querySelector('#landscape #BetBar #freespins #balanceContainer #balance_value') as HTMLElement;
                    const freespinsBetValue = document.querySelector('#landscape #BetBar #freespins #bet_value') as HTMLElement;

                    if (this.defaultLandscapeBalanceFontSize === undefined) {
                        this.defaultLandscapeBalanceFontSize = parseInt(window.getComputedStyle(betbarBalance).fontSize);
                    }
                    const currentFontSize = this.defaultLandscapeBalanceFontSize;
                    const expectedMaxLength = 10;
                    const defaultLength = betbarBalance.textContent?.length || 0;
                    const freespinsLength = freespinsBalance.textContent?.length || 0;
                    const length = defaultLength > freespinsLength ? defaultLength : freespinsLength;
                    if(length <= 12) return;

                    const resizedFontSize = this.downscale(
                        length,
                        expectedMaxLength,
                        currentFontSize,
                        currentFontSize - 4
                    );
                    betbarBalance.style.fontSize = `${resizedFontSize}px`;
                    betMenuBalance.style.fontSize = `${resizedFontSize}px`;
                    betValue.style.fontSize = `${resizedFontSize}px`;
                    betMenuBetValue.style.fontSize = `${resizedFontSize}px`;
                    freespinsBalance.style.fontSize = `${resizedFontSize}px`;
                    freespinsBetValue.style.fontSize = `${resizedFontSize}px`;
                } catch (e) {
                    this.disabled = true;
                }
            }
        }
    }

    private onLayoutChange = () => {
        setTimeout(() => this.scaleToFitBalanceOnMobile(), 10);
    }

    private downscale(length: number, expectedMaxLength: number, baseFontSize: number, minFontSize: number) {
        const scalingFactor = 1 - Math.max((length / expectedMaxLength) - 1, 0);

        return Math.ceil(Math.max(scalingFactor * (baseFontSize - minFontSize) + minFontSize, minFontSize));
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/betbar/bet-bar-resizer.ts